<app-page-title [breadcrumbItems]="pageTitle" title="{{'PROJECTS.SIDEBAR.SETTINGS' | translate}}"></app-page-title>

<div class="row">
    <p-megaMenu [model]="settingMenu"></p-megaMenu>


    <div>
        <div>
            <app-table-settings
                *ngIf="settingType !== 'BUG' && settingType !== 'NOTIFICATIONS' && settingType !== 'EMAILS'" #settings
                [type]="settingType" [projectId]="projectId"></app-table-settings>

            <app-issue-settings *ngIf="settingType === 'BUG'" [projectId]="projectId">
            </app-issue-settings>
        </div>
    </div>
</div>